import BaseComponent from '../abstracts/BaseComponent';

export default class ModalTriggerComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.init();
  }

  init() {
    this.GRAB(this.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen, this.onModalAfterOpen);

    if (this.$options.immediate) {
      this.open();
    }
    this.$on('click.modal', this.handleClick.bind(this));
  }

  get ZOOM_SELECTOR() {
    return this.$options.zoomimage;
  }

  open(e) {

    if (this.$options.element && !this.$options.close) {

      if (this.ZOOM_SELECTOR) {
        const img = this.$el.matches("img") ? this.$el : this.$el.querySelector("img");
        const mainImg = document.getElementById('mainImg');
        if (!img || !mainImg) {
        } else if (img.getAttribute('data-src')!=null){
          mainImg.setAttribute('data-src',img.getAttribute('data-src'));
          document.dispatchEvent(new Event('image-changes'));
        } else {
          mainImg.src = img.src;
        }
      } else {
        document.dispatchEvent(new Event('image-changes'));
      }
      
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
        selector: this.$options.element,
        className: this.$options.classname || '',
        overlayClassName: this.$options.overlayclassname || '',
        contentClassName: this.$options.contentclassname || '',
        closeClassName: this.$options.closeclassname || ''
      });
    } else {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
    }

     if (typeof addthis != "undefined") 
          addthis.toolbox('.socials');
     else
         console.log("addthis not loaded!")
  }

  handleClick(e) {
    // console.log('handleClick');
    if(e.target.classList.contains('isDisabled')){
      return;
    }

    this.open(e);

    // PITTI20-1392
    e.preventDefault();
  }

  onModalAfterOpen = event => {
    initVideos(event.vexInstance.contentEl);

    // PITTI20-1528
    if (this.$options.ignoreResize) {
      event.vexInstance.doNotCloseModalsOnResize = true;
    }
  }
}